import { useLatestFn } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { useProducer, useStore } from '../store/hooks.js';
import * as _Footer from '#~/common/editor/footer/index.js';
import { STagExt, STagInj } from '#~/stag/index.js';

/** Source `<Footer>` component. */
export const Footer = ({ className, ...sprops }: _Footer.Props): ReactElement => {
  const [stag, props] = STagExt(sprops);

  const producer = useProducer();
  const isReady = useStore((µ) => µ.source.isReady);

  const handleNext = useLatestFn(() => {
    producer((draft) => {
      if (draft.source.isReady) {
        draft.panel++;
      }
    });
  });

  return (
    <_Footer.Root className={twMerge('justify-end', className)} {...props}>
      <_Footer.Next disabled={!isReady} onClick={handleNext} {...STagInj(stag)} />
    </_Footer.Root>
  );
};
